define("powergen/models/system",
  [],
  function() {
    "use strict";
    var System;

    System = DS.Model.extend({
      name: DS.attr('string'),
      environment: DS.attr('string'),
      setting: DS.attr('string'),
      task: DS.attr('string'),
      improvements: DS.hasMany('improvement'),
      staticParts: DS.hasMany('staticPart'),
      parts: DS.hasMany('part'),
      points: DS.attr('number'),
      isComplete: DS.attr('boolean', {
        defaultValue: false
      }),
      reset: function() {
        this.setProperties({
          'points': null,
          'isComplete': false
        });
        return this.get('improvements').forEach(function(improvement) {
          return improvement.reset();
        });
      }
    });


    return System;
  });